<ng-container [ngSwitch]="steps$ | async">
  <ng-container *ngSwitchCase="StepsEnum.INTRO">
    <app-poll-web-intro
      *ngIf="!answered && !lockScreen; else unavailable"
      (typeSelected)="introOnSelectedType($event)"
    />
  </ng-container>
  <div *ngSwitchCase="StepsEnum.POLL">
    <lib-poll-manager
      *ngIf=" unitPoll.poll && !answered && !lockScreen; else unavailable"
      [poll]="unitPoll.poll"
      [incentive]="incentive"
      [isLoadingDone]="pollIsLoadingDone"
      (onFinishPoll)="onFinishPoll($event)"
    ></lib-poll-manager>
  </div>
</ng-container>

<ng-template #unavailable>
  <div *ngIf="answered && !lockScreen" class="cooldown-message">
    <h2>Votacao temporariamente indisponivel</h2>
    <p>
      Aguarde {{ cooldownRemainingMinutes }}
      {{ cooldownRemainingMinutes === 1 ? 'minuto' : 'minutos' }} para votar novamente neste dispositivo.
    </p>
  </div>

  <app-page-unavailable *ngIf="!answered || lockScreen"></app-page-unavailable>
</ng-template>
